module.exports = __webpack_public_path__ + "img/BNCC.a973d1fa.png";